<template>
  <div class="calendar-rooms">
    <h2 class="center-title" v-if="center">
      {{ center.name }}
    </h2>
    <!--<input type="date" />-->
    <v-date-picker class="calendar"
      :locale="this.$i18n.locale"
      color="red darken-1"
    >
    </v-date-picker>
  </div>
</template>

<script>
export default {
  name: "RoomsCalendar",
  props: ["center"],
};
</script>

<style>
.center-title {
  text-align: center;
  text-transform: uppercase;
  flex-flow: row;
}
.calendar {
  align-content: center;
  flex-flow: row;
}

</style>
